import { render } from "./StockProCIView.vue?vue&type=template&id=ba0b032c&scoped=true"
import script from "./StockProCIView.vue?vue&type=script&lang=js"
export * from "./StockProCIView.vue?vue&type=script&lang=js"

import "./StockProCIView.vue?vue&type=style&index=0&id=ba0b032c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba0b032c"]])

export default __exports__